import { URL_BIBLE } from "../../../lib/constants/urls/urlBible";
import { bibleSearchableSchema } from "../../../lib/types/schema/bible/bibleSearchableSchema";
import type { CloudfrontCookie } from "../../../lib/types/schema/cloudfrontCookieSchema";
import { signCFUrl } from "../../../lib/utils/signCFUrl";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyBibleJSON } from "./keyBibleHTML";

type Props = {
  translationId: number;
  cookies: CloudfrontCookie[];
};

export const useRequestBibleJSON = ({ translationId, cookies }: Props) =>
  useRequestQuery<typeof bibleSearchableSchema>({
    enabledWithoutSessionToken: true,
    queryFnRequestProps: {
      schema: bibleSearchableSchema,
      url: signCFUrl(
        `${URL_BIBLE}/translations/book/${translationId}/searchable.json`,
        cookies,
      ),
      requestType: "other",
    },
    queryKey: keyBibleJSON({
      cookies: JSON.stringify(cookies),
      translationId,
    }),
  });
